export default "__VITE_ASSET__CkDUsctE__"